const ACTION_PATH = 'app/dashboard'

export const CALL_LISTAR_DADOS_DASHBOARD = `${ACTION_PATH}/CALL_LISTAR_DADOS_DASHBOARD`

export const callListarDadosDashboard = (payload) => ({
  type: CALL_LISTAR_DADOS_DASHBOARD,
  payload,
})
